import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

export const spinnerWrapperCss: CSSObject = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  backgroundColor: constants.colors.ui.white[700],
  opacity: "80%",
};

export const wrapperContainerCss: CSSObject = {
  position: "relative",
};

export const buttonSpinnerCss: CSSObject = {
  width: "20px",
  height: "20px",
  margin: "1em auto",
};
